import { Link } from "react-router-dom";
import { formatDate, newsArticles } from "@/lib/content";

export default function NewsPreview() {
  const items = [...newsArticles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, 3);

  return (
    <section className="w-full border-t border-background-200/70 bg-background-100/40 px-4 py-12 md:px-6 lg:px-10 lg:py-16">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-label uppercase tracking-widest text-primary-400">
            <span className="h-1 w-6 rounded-full bg-primary-500" />
            影视动态
          </span>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">影视资讯精选</h2>
        </div>
        <Link
          to="/news"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-label text-foreground-600 transition-colors duration-200 hover:text-primary-400"
        >
          全部资讯
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100/60 transition-colors duration-300 hover:border-primary-500/60"
          >
            <div className="h-40 w-full overflow-hidden bg-background-200 md:h-44">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} - 夜无疆影视资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line" />
                  {formatDate(item.publishDate)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-price-tag-3-line" />
                  {item.source}
                </span>
              </div>
              <h3 className="mt-3 line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors duration-200 group-hover:text-primary-400">
                {item.title}
              </h3>
              <p className="mt-2 line-clamp-3 flex-1 text-sm leading-7 text-foreground-600">{item.summary}</p>
              <span className="mt-4 text-xs font-label text-primary-400">
                查看全文 <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}